import * as React from "react";

function SvgTv(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 42 42"
      {...props}
    >
      <g
        stroke="currentColor"
        strokeWidth={1.8}
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M36.833 40.167H5.167a3.336 3.336 0 01-3.334-3.334V13.5a3.335 3.335 0 013.334-3.333h31.666a3.335 3.335 0 013.334 3.333v23.333a3.336 3.336 0 01-3.334 3.334z" />
        <path d="M26.833 35.167H8.5A1.665 1.665 0 016.833 33.5V16.833c0-.921.745-1.666 1.667-1.666h18.333c.922 0 1.667.745 1.667 1.666V33.5c0 .922-.745 1.667-1.667 1.667zm0-25H13.5c0-1.84 2.985-3.334 6.667-3.334 3.681 0 6.666 1.494 6.666 3.334zM33.5 1.833l-10 5m-16.667-5l10 5M33.5 18.5h3.333m-3.333 5h3.333m-3.333 5h3.333" />
      </g>
    </svg>
  );
}

export default SvgTv;
